import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'office-ui-fabric-react/lib/Link';
import {
  ActionButton,
  DefaultButton,
  PrimaryButton,
} from 'office-ui-fabric-react/lib/Button';
import { Grid, GridRow, Column } from '../common';
import { EmptyView } from '../EmptyView';
import { ExpendituresList } from '../ExpendituresList';
import { getLabel } from '../../helpers/labelHelper';

const ItemizedDisbursements = ({
  sectionName,
  state,
  toggleExpandSection,
  session,
  addNewDisbursement,
  editDisbursement,
  items,
}) => {
  const renderList = () =>
    items.length > 0 ? (
      <ExpendituresList
        editItem={editDisbursement}
        expenditures={{
          ...items,
          expenditures: [...items],
        }}
        session={session}
        isHidden={state.expandableSections[sectionName] === false}
      />
    ) : (
      <EmptyView
        message={`There are no ${getLabel(
          'expenditures',
          session,
        )} this reporting period.`}
      />
    );

  return (
    <div
      className="ItemizedDisbursements fec-report-section depth-1"
      name={sectionName}
    >
      <h3>
        DISBURSEMENTS{' '}
        <small>
          {' '}
          (
          <Link onClick={() => toggleExpandSection(sectionName, false)}>
            {state.expandableSections[sectionName] === true
              ? 'Collapse'
              : 'Expand'}
          </Link>
          )
        </small>
      </h3>
      <div
        className={`fec-itemizedDisbursements${
          state.expandableSections[sectionName] === true
            ? '-expanded'
            : '-collapsed'
        }`}
      >
        <Grid>
          <GridRow>
            <Column classNames="ms-textAlignRight">
              <ActionButton
                text="Add New Disbursement"
                iconProps={{
                  iconName: 'PlusCircle',
                  styles: {
                    root: {
                      fontSize: '1.3em',
                    },
                  },
                }}
                onClick={addNewDisbursement}
              />
            </Column>
          </GridRow>
          {renderList()}
        </Grid>
        <div className="section-actions">
          <DefaultButton
            text="Previous Section"
            style={{ marginRight: 16 }}
            onClick={() => toggleExpandSection('itemizedReceipts', false)}
          />
          <PrimaryButton
            text="Save & Continue"
            onClick={() => toggleExpandSection('itemizedLoans', true)}
          />
        </div>
      </div>
    </div>
  );
};

ItemizedDisbursements.propTypes = {
  sectionName: PropTypes.string.isRequired,
  state: PropTypes.object.isRequired,
  toggleExpandSection: PropTypes.func.isRequired,
  session: PropTypes.object.isRequired,
  addNewDisbursement: PropTypes.func.isRequired,
  editDisbursement: PropTypes.func.isRequired,
  items: PropTypes.array,
};

ItemizedDisbursements.defaultProps = {
  items: [],
};

export default ItemizedDisbursements;
